import './_header.scss';

export default function Header() {
    const $header = document.querySelector('.header') as HTMLElement;

    if ($header) {
        let headerHeight: any;
        const $programMenuDropdown = $header.querySelector('.sub-menu-title') as HTMLElement;
        const $linksDropdown = $header.querySelectorAll('.link-menu');
        const $menuLinksMobile = $header.querySelector('.menu-links-mobile') as HTMLElement;
        const $burgerMenuIcn = $header.querySelector('.icn-burger-menu') as HTMLElement;
        const $sideMenu = $header.querySelector('.menu-section') as HTMLElement;
        const $bottomMenu = $header.querySelector('.menu-mobile') as HTMLElement;
        const $subMenuMobile = $header.querySelector('.sub-menu.mobile') as HTMLElement;
        const $linksMobile = $header.querySelectorAll('.links');
        const $thirdLevelHeader = $header.querySelector('.list-links-menu') as HTMLElement;
        const mainWrapper = document.querySelector('#main-wrapper') as HTMLElement;
        const $icnClose = $subMenuMobile.querySelector('.icn-close') as HTMLElement;
        const $linksTopHeader = $header.querySelectorAll('.menu .link-menu');
        const $socialWidget = $header.querySelector('.social-widget') as HTMLDivElement;
        const $footer = document.querySelector('footer') as HTMLElement;

        function updateWidgetPosition() {
            if ($socialWidget) {
                const footerRect = $footer.getBoundingClientRect();
                const footerVisibleHeight = Math.max(0, window.innerHeight - footerRect.top);
                if (window.innerWidth > 1200) {
                    $socialWidget.style.bottom = `${footerVisibleHeight + 20}px`;
                } else {
                    if (footerVisibleHeight > 65) {
                        $socialWidget.style.bottom = `${footerVisibleHeight + 20}px`;
                    } else {
                        $socialWidget.style.bottom = `${footerVisibleHeight + 85}px`;
                    }
                }
            }
        }

        window.addEventListener('scroll', updateWidgetPosition);
        window.addEventListener('resize', updateWidgetPosition);

        updateWidgetPosition();

        if ($linksTopHeader.length) {
            $linksTopHeader.forEach($el => {
                $el.addEventListener('click', () => {
                    $linksTopHeader.forEach(link => link.classList.remove('active'));
                    $el.classList.add('active');
                });

                $el.addEventListener('keyup', (e: any) => {
                    if (e.key === 'Enter') {
                        $linksTopHeader.forEach(link => link.classList.remove('active'));
                        $el.classList.add('active');
                    }
                });

                const link = ($el.querySelector('a') as HTMLAnchorElement).href;
                if (window.location.href === link || window.location.href.indexOf(link) === 0) {
                    $linksTopHeader.forEach(link => link.classList.remove('active'));
                    $el.classList.add('active');
                }
            });
        }

        if ($programMenuDropdown) {
            $programMenuDropdown.addEventListener('click', () => {
                ($programMenuDropdown.parentElement as HTMLElement).classList.toggle('open');
            });
            $programMenuDropdown.addEventListener('keypress', function (e) {
                if (e.code === 'Enter') {
                    ($programMenuDropdown.parentElement as HTMLElement).classList.toggle('open');
                }
            });
            mainWrapper.addEventListener('click', () => {
                ($programMenuDropdown.parentElement as HTMLElement).classList.remove('open');
            });
        }

        if ($thirdLevelHeader && $programMenuDropdown) {
            $thirdLevelHeader.addEventListener('click', () => {
                ($programMenuDropdown.parentElement as HTMLElement).classList.remove('open');
            });
        }

        if ($linksMobile.length > 0) {
            $linksMobile.forEach(item => {
                const subMenu = item.querySelector('.link-wrapper');
                const arrowDown = item.querySelector('.icn-arrow-down') as HTMLElement;
                if (subMenu) {
                    arrowDown.classList.remove('d-none');
                }
            });
        }

        if ($linksDropdown.length > 0) {
            $linksDropdown.forEach(item => {
                const popUp = item.querySelector('.pop-up-links');
                const arrowDown = item.querySelector('.icn-arrow-down') as HTMLElement;
                if (popUp) {
                    arrowDown.classList.remove('d-none');
                }
                mainWrapper.addEventListener('click', () => {
                    item.classList.remove('visible');
                });

                if (item.querySelector('.pop-up-links')) {
                    item.addEventListener('click', () => {
                        $linksDropdown.forEach(link => {
                            if (link !== item) {
                                link.classList.remove('visible');
                            }
                        });
                        item.classList.toggle('visible');
                    });

                    item.addEventListener('keypress', (e: any) => {
                        if (e.code === 'Enter') {
                            $linksDropdown.forEach(link => {
                                if (link !== item) {
                                    link.classList.remove('visible');
                                }
                            });
                            item.classList.toggle('visible');
                        }
                    });
                } else {
                    item.setAttribute('data-make-me-accessible', '');
                    item.setAttribute('data-full-open-page', '');
                }
            });
        }

        function openSideMenu() {
            if ($menuLinksMobile) {
                const linksMenuMobile = $menuLinksMobile.querySelectorAll('.links');
                linksMenuMobile.length > 0 &&
                    linksMenuMobile.forEach(item => {
                        if (item.querySelector('.link-wrapper')) {
                            item.addEventListener('click', () => {
                                item.classList.toggle('visible');
                            });

                            item.addEventListener('keypress', (e: any) => {
                                if (e.key === 'Enter') {
                                    item.classList.toggle('visible');
                                }
                            });
                        } else {
                            (item.querySelector('.link-content') as HTMLElement).setAttribute('data-make-me-accessible', '');
                            (item.querySelector('.link-content') as HTMLElement).setAttribute('data-full-open-page', '');
                        }
                    });
            }

            if ($burgerMenuIcn) {
                $burgerMenuIcn.addEventListener('click', () => {
                    $sideMenu.classList.toggle('open');
                    document.body.classList.toggle('open-modal');

                    if ($sideMenu.classList.contains('open')) {
                        $bottomMenu.setAttribute('tabindex', '-1');
                    } else {
                        $bottomMenu.setAttribute('tabindex', '0');
                    }
                });

                $burgerMenuIcn.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        $sideMenu.classList.toggle('open');
                        document.body.classList.toggle('open-modal');

                        if ($sideMenu.classList.contains('open')) {
                            $bottomMenu.setAttribute('tabindex', '-1');
                        } else {
                            $bottomMenu.setAttribute('tabindex', '0');
                        }
                    }
                });
            }
        }

        function openBottomMenu() {
            if ($bottomMenu) {
                $bottomMenu.addEventListener('click', () => {
                    $subMenuMobile.classList.add('open');
                    document.body.classList.add('open-modal');
                });

                $bottomMenu.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        $subMenuMobile.classList.add('open');
                        document.body.classList.add('open-modal');
                        $icnClose.focus();
                    }
                });
            }

            headerHeight = $header.clientHeight;

            if ($subMenuMobile) {
                $subMenuMobile.style.top = `${headerHeight}px`;
            }

            window.addEventListener('resize', () => {
                headerHeight = $header.clientHeight;
                if ($subMenuMobile) {
                    $subMenuMobile.style.top = `${headerHeight}px`;
                }
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > headerHeight) {
                    if ($subMenuMobile) {
                        $subMenuMobile.style.top = '0px';
                    }
                } else {
                    if ($subMenuMobile) {
                        $subMenuMobile.style.top = `${headerHeight}px`;
                    }
                }
            });
        }

        function closeBottomMenu() {
            if ($icnClose) {
                $icnClose.addEventListener('click', () => {
                    $subMenuMobile.classList.remove('open');
                    document.body.classList.remove('open-modal');
                });

                $icnClose.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        $subMenuMobile.classList.remove('open');
                        document.body.classList.remove('open-modal');
                    }
                });
            }
        }

        openSideMenu();
        openBottomMenu();
        closeBottomMenu();
    }
}
